import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState, useAppThunkDispatch } from '../../redux/store';
import { Paper, Stack, Box, Typography, LinearProgress, } from '@mui/material';
import stylesheet from './tasks.stylesheet';
import { ClassNameMap, withStyles } from '@mui/styles';
import { getMetaData } from '../../redux/meta-data-slice';
import AllTaskListComponent from './all-task-list.component';
import Helper from '../../utils/helper';

interface IProps {
  classes: ClassNameMap
}

const TaskListComponent: React.FC<IProps> = ({ classes }) => {
  const loggedInUser = useSelector((state: RootState) => state.commonData.loggedInUser)
  const [assigneeId, setAssigneeId] = useState(null) as any
  const [isAllTaskLoading, setIsAllTaskLoading] = useState(null) as any
  const [isInitializing, setIsInitializing] = useState(true) // New state

  const location: any = useLocation();
  const dispatch = useAppThunkDispatch()

  useEffect(() => {
    if (loggedInUser && localStorage.getItem("access_token"))
      dispatch(getMetaData())
  }, [])

  useEffect(() => {
    setIsInitializing(true)
    const assigneeRef: any = (location.pathname == '/all-tasks') ? "*" : getAssigneeId();
    if (assigneeRef !== undefined) {
      setAssigneeId(assigneeRef)
      setIsInitializing(false)
    } else {
      setIsInitializing(false)
    }

  }, [loggedInUser.sub, location.pathname]);

  const getAssigneeId = () => Helper.isOIDC() ? loggedInUser?.oid : loggedInUser?.sub
  const updateStatus = (flag: boolean) => setIsAllTaskLoading(flag)

  return (
    <Stack spacing={0} direction={'row'} sx={{ width: '99.5%' }}>
      <Box sx={{ width: '-webkit-fill-available', padding: '0.8rem 0rem 0rem 1.13rem !important', position: 'absolute' }}>
        {(isAllTaskLoading || isInitializing) &&
          <LinearProgress sx={{ margin: '-0.8rem 0rem 0rem -0.68rem !important' }} />
        }
        <Typography variant="subtitle2" sx={{ marginTop: isAllTaskLoading ? '0.5rem' : '0rem' }}>
          <strong>{`${(location.pathname == '/all-tasks') ? 'All' : (location.pathname == '/top-tasks') ? 'Top daily' : 'My'} tasks`}</strong>
        </Typography>
      </Box>
      <Paper sx={{ width: "100%", padding: '1.8rem 1rem 0rem 0.1rem', backgroundColor: 'var(--color-body-background)', }}>
        <Box className={classes.containerPadding}>
          {((!Helper.isAIDA() && loggedInUser?.sub && assigneeId) || Helper.isAIDA())
            ? <AllTaskListComponent
              assigneeId={assigneeId}
              handleTaskLoading={updateStatus}
            />
            : <Box sx={{ minHeight: '15rem' }}>
              {!isAllTaskLoading &&
                <Typography variant="body2" color="textSecondary" pl={1} pt={1.5}>
                  {/* {`Tasks not available.`} */}
                </Typography>
              }
            </Box>
          }
        </Box>
      </Paper>
    </Stack>
  );
}

export default withStyles(stylesheet)(TaskListComponent);